import React from 'react';

const IconLogo = () => (
  <img src="/favicon-32x32.png" style={{ width: '50px', maxWidth: 'initial' }} alt="Logo" />
);

export default IconLogo;
